import { render, staticRenderFns } from "./PublicationOpened04.vue?vue&type=template&id=1418dd2b"
import script from "./PublicationOpened04.vue?vue&type=script&lang=js"
export * from "./PublicationOpened04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports